import { Link } from 'react-router-dom';
import CodeSnippet from './CodeSnippet';
import { PATH_CONTACT, PATH_DOCS } from '@/constants';
import { ArrowTopRightIcon } from '@radix-ui/react-icons';
import { Button } from '@/components/ui/button';

const LLMOverview = () => {
  return (
    <div className="container">
      <p className="text-2xl font-medium">LLM as a service</p>
      <div className="mt-4 flex justify-between">
        <div>Please copy the following code and paste it to test the API</div>
        <div className="flex gap-2">
          <Link
            to={PATH_CONTACT.support}
            className="underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button variant={'link'}>Any help?</Button>
          </Link>
          <Link
            to={PATH_DOCS.root}
            className="underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button variant={'link'} endIcon={<ArrowTopRightIcon />}>
              Docs
            </Button>
          </Link>
        </div>
      </div>
      <CodeSnippet />
    </div>
  );
};

export default LLMOverview;
